export default __webpack_public_path__ + "static/media/supabase.acfb8429.svg";